var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithubIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_297_826)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49972 0.186857C3.35843 0.186857 0 3.54472 0 7.68655C0 11.0004 2.1487 13.8107 5.12873 14.8029C5.50383 14.8724 5.64169 14.6398 5.64169 14.4416C5.64169 14.2628 5.63421 13.672 5.63116 13.0459C3.54448 13.4996 3.1046 12.1606 3.1046 12.1606C2.76354 11.2936 2.27189 11.063 2.27189 11.063C1.59145 10.5971 2.32366 10.6073 2.32366 10.6073C3.07662 10.6599 3.47304 11.3797 3.47304 11.3797C4.14241 12.5263 5.22811 12.1944 5.6558 12.0031C5.72334 11.5183 5.91712 11.1873 6.13193 10.9999C4.46599 10.8108 2.71481 10.1675 2.71481 7.29346C2.71481 6.47488 3.00825 5.80553 3.48743 5.28065C3.40938 5.09132 3.15248 4.32894 3.55969 3.2961C3.55969 3.2961 4.18945 3.0943 5.62287 4.06485C6.2208 3.89903 6.8622 3.81543 7.49918 3.81266C8.13668 3.81543 8.7792 3.89875 9.37798 4.06485C10.8094 3.09487 11.4386 3.2961 11.4386 3.2961C11.8464 4.32922 11.5906 5.09214 11.5126 5.28067C11.9934 5.80553 12.2844 6.47488 12.2844 7.29346C12.2844 10.1741 10.5293 10.8074 8.85975 10.9932C9.12884 11.2257 9.36912 11.6822 9.36912 12.3815C9.36912 13.3844 9.36054 14.1927 9.36054 14.4394C9.36054 14.639 9.49563 14.8723 9.87598 14.7992C12.8543 13.8066 15.0003 10.996 15.0003 7.68404C15.0003 3.54276 11.6424 0.184326 7.50028 0.184326L7.49974 0.186834L7.49972 0.186857Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_297_826"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubIcon);
export default __webpack_public_path__ + "static/media/github-icon.41371a036bb8a83b839689489b93b485.svg";
export { ForwardRef as ReactComponent };